module.exports = __webpack_public_path__ + "img/zhu_xc13.74dab366.jpg";